"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WafContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _internals = require("../../internals");
var _ErrorButton = require("../ErrorButton");
var _PageHeader = require("../PageHeader");
var _SupportId = require("../SupportId");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const WafContent = ({
  contactSupportTeamText,
  errorCode,
  headerText,
  messageText,
  errorButtonText
}) => {
  // Support ID from query - used by WAF
  const supportId = (0, _react.useRef)((0, _internals.getUrlQueryParam)('support-id'));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PageHeader.PageHeader, {
      errorCode: errorCode,
      headerText: headerText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: messageText
    }), supportId.current ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      children: [contactSupportTeamText, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledLink, {
        href: `mailto:ServiceDesk@oriflame.com?Subject=SupportID:${supportId.current}`,
        children: "ServiceDesk@oriflame.com"
      })]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorButton.ErrorButton, {
      text: errorButtonText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SupportId.SupportId, {
      supportId: supportId.current
    })]
  });
};
exports.WafContent = WafContent;
